module.exports = __webpack_public_path__ + "assets1779866876160/img/lan4.5dcca9c1.png";